module.exports = __webpack_public_path__ + "static/01-george@2x-9620af974c3cbf814f56106ea96bac22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/01-george@2x.jpg
// module id = 2512
// module chunks = 168707334958949